import React from "react";
import DefaultCard from "./default";

const Card5 = (props) => {

    return (
        <DefaultCard {...props} style={{
            cardContainer: `card5 py-[24px] px-[30px] relative [&:after]:top-[0] [&:after]:left-center [&:after]:h-[2px] [&:after]:w-[102px] [&:first-child:after]:hidden [&:after]:content-[''] [&:after]:absolute lg:[&:after]:h-[102px] lg:[&:after]:w-[2px] [&:after]:bg-[#6494A199] lg:[&:after]:left-0 lg:[&:after]:top-[calc(50%-51px)]`,
            contentContainer: ``,
            linkContainer: ``,
            mediaContainer: `pb-[10px]`,
        }} />
    );
};

export default Card5;